module.exports = __webpack_public_path__ + "media/assets/cart-98a73635bcd75d013b0d4bed0f4d729e.svg";